// NPM
import React, { useState } from "react"
import _ from "lodash"

// Form Components
import TextField from "src/components/Shared/FormFields/TextField"
import Dropdown from "src/components/Shared/FormFields/Dropdown"

// Constants
const submissionUrl = "https://contact.voxpoplabs.com"

const ContactForm = ({ contactForm, contactFormSection }) => {
  const [formData, setFormData] = useState({})
  const [formSubmitted, setFormSubmitted] = useState(false)

  const setFormDataField = (formField, value) => {
    setFormData({
      ...formData,
      [formField.uuid]: {
        fieldName: formField.name,
        value,
      },
    })
  }

  const submitForm = async e => {
    e.preventDefault()

    const response = await fetch(submissionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })

    setFormSubmitted(true)
  }

  if (!contactForm) {
    return null
  }

  const formSubmittedText = (
    contactFormSection.miscText.find(mt => mt.uuid === "formSubmitted_text") ||
    {}
  ).text

  return (
    <div className="ContactForm">
      <form onSubmit={submitForm}>
        {_.get(contactForm, "fields", []).map((formField, formFieldIndex) => {
          switch (formField.strapi_component) {
            case "form.text-field":
              return (
                <TextField
                  formField={formField}
                  key={`FormField-${formFieldIndex}`}
                  onChange={value => setFormDataField(formField, value)}
                  value={_.get(formData, `${formField.uuid}.value`, "")}
                  required={true}
                />
              )

            case "form.dropdown":
              return (
                <Dropdown
                  formField={formField}
                  key={`FormField-${formFieldIndex}`}
                  onChange={value => setFormDataField(formField, value)}
                  value={_.get(formData, `${formField.uuid}.value`, "")}
                  required={true}
                />
              )

            default:
              return null
          }
        })}

        <button className="ContactForm__submit black-button" role="submit">
          <span>{contactForm.submitText}</span>
          <span className="icon">
            <img
              src={require("src/images/icons/arrow-right-white.png").default}
            />
          </span>
        </button>
      </form>

      {formSubmitted && (
        <div className="ContactForm__form-submitted">
          <p>{formSubmittedText}</p>
        </div>
      )}
    </div>
  )
}

export default ContactForm
